import React, { useState } from "react";

const useNotice = () => {
  const [notice, setNotice] = useState({
    kind: "error",
    open: false,
    message: "",
  });

  return { notice, setNotice };
};

export default useNotice;
